import { FaArtstation } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { RiMore2Fill } from "react-icons/ri";
import {
  TbBrandLinktree,
  TbBrandInstagram,
  TbBrandGithub,
  TbBrandLinkedin,
} from "react-icons/tb";
import { Link } from "react-router";

import { useAppConfig } from "../../providers/ConfigProvider";
import { NewsletterForm } from "../NewsletterForm";

const socialLinkClass =
  "flex items-center justify-center size-10 transition-colors duration-300 ease-out hover:bg-nav-dark hover:text-nav-light active:bg-nav-light active:text-nav-dark";

interface SocialLinksDropdownProps {
  compact?: boolean;
}

const SocialLinksDropdown = ({ compact = false }: SocialLinksDropdownProps) => {
  const { convertkitFormId } = useAppConfig();
  const hiddenClass = compact ? "hidden" : "lg:hidden";
  return (
    <div className="dropdown dropdown-end">
      <div
        tabIndex={0}
        role="button"
        className={`tooltip tooltip-top tooltip-delayed ${socialLinkClass} focus:bg-nav-light focus:text-nav-dark cursor-pointer`}
        data-tip="More ways to connect"
        aria-label="More social links"
      >
        <RiMore2Fill size={24} />
      </div>
      <ul
        tabIndex={-1}
        className="dropdown-content menu bg-base-100 rounded-box mt-2 p-2 shadow-sm"
      >
        <li>
          <Link
            to="https://www.artstation.com/turtlewave"
            target="_blank"
            rel="noopener noreferrer"
            className="flex min-w-52 items-center gap-3"
          >
            <FaArtstation size={20} />
            <span>ArtStation</span>
          </Link>
        </li>
        <li>
          <Link
            to="https://github.com/JayDosunmu"
            target="_blank"
            rel="noopener noreferrer"
            className="flex min-w-52 items-center gap-3"
          >
            <TbBrandGithub size={22} />
            <span>GitHub</span>
          </Link>
        </li>
        <li>
          <Link
            to="https://www.linkedin.com/in/taslimdosunmu/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex min-w-52 items-center gap-3"
          >
            <TbBrandLinkedin size={22} />
            <span>LinkedIn</span>
          </Link>
        </li>
        <hr className={`mt-2 mb-4 ${hiddenClass}`} />
        <div className={`p-4 ${hiddenClass}`}>
          <NewsletterForm formId={convertkitFormId} />
        </div>
      </ul>
    </div>
  );
};

interface SocialLinksProps {
  compact?: boolean;
}

export function SocialLinks({ compact = false }: SocialLinksProps) {
  const className = compact
    ? "flex flex-row gap-6 pl-2 mt-12 items-center order-2"
    : "flex flex-row gap-6 pl-2 mt-3 lg:mt-12 items-center lg:order-2";

  return (
    <div className={className}>
      <Link
        to="https://www.instagram.com/turtlewave.art"
        target="_blank"
        rel="noopener noreferrer"
        className={`tooltip tooltip-top tooltip-delayed ${socialLinkClass}`}
        data-tip="Follow on Instagram"
        aria-label="Instagram"
      >
        <TbBrandInstagram size={28} />
      </Link>
      <Link
        to="https://linktr.ee/turtlewave"
        target="_blank"
        rel="noopener noreferrer"
        className={`tooltip tooltip-top tooltip-delayed ${socialLinkClass}`}
        data-tip="Latest Linktree"
        aria-label="Linktree"
      >
        <TbBrandLinktree size={24} />
      </Link>
      <a
        href="mailto:turtlewave.art@gmail.com"
        className={`tooltip tooltip-top tooltip-delayed ${socialLinkClass}`}
        data-tip="Contact"
        aria-label="Email"
      >
        <HiOutlineMail size={28} />
      </a>
      <SocialLinksDropdown compact={compact} />
    </div>
  );
}
